export {} // Make this a module

declare global {
  interface Window {
    __REACT_DEVTOOLS_GLOBAL_HOOK__?: {
      renderers: { [key: string]: any }
      inject: () => void
    }
  }
}

if (process.env.NODE_ENV === 'production') {
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
    if (Object.keys(window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers).length) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__.renderers = {}
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () { }
    }
  }
}